import React, { useRef } from 'react';

import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';

export const AnimationDelay = 100;
export default function FilterControls(props) {
  const {
    firstLoadStyle,
    setFirstLoad,
    showResults,
    setShowResults,
    showFilters,
    setShowFilters,
  } = props;

  const showButtonRef = useRef(null);
  const hideButtonRef = useRef(null);

  return (
    <div className="snapgadget-filter-btn-container">
      <CSSTransition
        in={showResults}
        timeout={AnimationDelay}
        classNames="snapgadget-slide"
        unmountOnExit
        onExited={() => {
          setShowFilters(true);
          setFirstLoad(false);
        }}
        nodeRef={showButtonRef}
      >
        <button
          ref={showButtonRef}
          type="button"
          aria-expanded={showResults}
          aria-label="Show filters"
          className="snapgadget-btn-icon"
          onClick={() => {
            setShowResults(false);
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-sliders" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3h9.05zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8h2.05zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1h9.05z" />
          </svg>
          <div className="snapgadget-button-text">Show Filters</div>
        </button>
      </CSSTransition>

      <CSSTransition
        in={showFilters}
        timeout={AnimationDelay}
        classNames="snapgadget-slide"
        unmountOnExit
        onExited={() => setShowResults(true)}
        nodeRef={hideButtonRef}
      >
        <button
          ref={hideButtonRef}
          type="button"
          style={firstLoadStyle}
          aria-expanded={showFilters}
          aria-label="Hide filters"
          className="snapgadget-btn-icon"
          onClick={() => {
            setShowFilters(false);
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z" />
            <path fillRule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z" />
          </svg>
          <div className="snapgadget-button-text">Hide Filters</div>
        </button>
      </CSSTransition>
    </div>
  );
}

FilterControls.propTypes = {
  firstLoadStyle: PropTypes.shape({}).isRequired,
  setFirstLoad: PropTypes.func.isRequired,
  showResults: PropTypes.bool.isRequired,
  setShowResults: PropTypes.func.isRequired,
  showFilters: PropTypes.bool.isRequired,
  setShowFilters: PropTypes.func.isRequired,
};
